import Store from 'store'
import componentsToInititalize from './component-index.generated'
import 'foundation/js/loadLabels'
import 'foundation/js/animatedButtonHandler'
import 'foundation/js/formFileUploads'

componentsToInititalize(Store)
